/* import __COLOCATED_TEMPLATE__ from './credit-card-balances.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { CardState } from '@square/dashboard-protos/models/squareup/cardr/issuing/model';
import { action } from '@ember/object';
import { addBusinessDate, getStartOfDay } from '@banking/ui/utils/date-math';
import { TrackerStatus } from '@squareup/banking-shared-ui/card';
let CreditCard = (_class = class CreditCard extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _initializerDefineProperty(this, "corporateCardApi", _descriptor, this);
    _initializerDefineProperty(this, "issuedCardService", _descriptor2, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor3, this);
  }
  get totalOutstanding() {
    return this.corporateCardApi.creditLine.balanceSummary.totalBalanceMoney;
  }
  get availableCredit() {
    return this.corporateCardApi.creditLine.balanceSummary.availableBalanceMoney;
  }
  get cardIssuedDate() {
    const {
      day,
      month,
      year
    } = this.issuedCardService.issuedCard.issuedDate;
    // months from the API start at 1
    return new Date(`${month}/${day}/${year}`);
  }
  get panSuffix() {
    return this.issuedCardService.issuedCard.fullPan.slice(10, 15);
  }
  get isOpenAccount() {
    return this.issuedCardService.issuedCard.cardState !== CardState.TERMINATED;
  }
  get cardNeedsActivation() {
    return !this.issuedCardService.issuedCard.isActivated;
  }
  get trackableCardArrivalDate() {
    const issuedDate = this.cardIssuedDate;
    return addBusinessDate(issuedDate, 10);
  }
  get trackableCardShipDate() {
    const issuedDate = this.cardIssuedDate;
    return addBusinessDate(issuedDate, 4);
  }
  get cardTrackerStatus() {
    const now = getStartOfDay(new Date());
    if (now < this.trackableCardShipDate) {
      return TrackerStatus.Processing;
    } else if (now >= this.trackableCardArrivalDate) {
      return TrackerStatus.Delivered;
    }
    return TrackerStatus.Shipped;
  }
  goToActivation() {
    this.applicationRouter.transitionToExternal('credit-card-activation');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "corporateCardApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "issuedCardService", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "goToActivation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToActivation"), _class.prototype), _class);
export { CreditCard as default };